import BaseServiceCrud from './BaseServiceCrud';


export default class ProjectUserService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'user-project';
    }
    getCriteria(criteria) {
        return this.objToQueryString({         
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getList(userId, criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/${userId}/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
